export const ACCESS_TOKEN = 'access_token';
export const BANK_ID = 'bank_id';
export const DEVICE_ID = 'device_id';
export const ACCOUNT_ID = 'account_id';
export const APP_ID = 'app_id';
export const APP_ID_PCA_APP = 'pca_app';
export const APP_ID_CREDIT_CARD_APP = 'credit_card_app';
export const APP_ID_ONE_REDI = 'one_redi';
export const CUSTOM_CONTEXT = 'custom_context';
export const OUTBOUND_CONTEXT = 'OUTBOUND_CONTEXT';
export const OUTBOUND_CONTEXT_VARIABLES = 'OUTBOUND_CONTEXT_VARIABLES';
export const APP_ID_BUSINESS_BANKING = 'business_banking';
export const BOT_CHANNEL = 'bot_channel';
export const BOT_CHANNEL_MOBILE = 'mobile';
//Dynatrace Constants
export const APP_NAME_PCA = 'pca';
export const APP_NAME_CREDIT_CARD = 'credit_card';
export const APP_NAME_SMA = 'SMA';
export const BOT_NAME_PCA = 'pca_redi';
export const BOT_NAME_CREDIT_CARD = 'credit_card_redi';
export const BOT_NAME_ONEREDI = 'one_redi';
export const BOT_NAME_BB_REDI = 'business_banking_redi';
